<template>
  <BaseDialog centered contentClass="rename-opportunity" ref="dialog" :show-actions="true">
    <template slot="title">{{ $t('page.opportunity-details.opportunity-manipulations.rename') }}</template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <FormInput
          ref="opportunityName"
          :label="$t('page.opportunities.data-table-titles.title')"
          has-gray-background
          is-textarea
          name="text"
          v-model="value"
          v-validate="'required'"
        />

        <div class="rename-opportunity__actions">
          <FormButton is-outlined class="rename-opportunity__cancel" @click.native="cancelClick">{{
            $t('actions.cancel')
          }}</FormButton>
          <FormButton @click.native="onSubmit" type="submit" :disabled="isFormInvalid || !hasChanged">
            <span>{{ $t('dialog.filters.advanced.apply') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput.vue';

import { mapActions } from 'vuex';

export default {
  name: 'RenameOpportunityDialog',
  components: {
    BaseDialog,
    FormButton,
    FormInput,
  },
  data() {
    return {
      value: '',
      opportunity: null,
    };
  },
  computed: {
    isFormInvalid() {
      return !!!this.value;
    },
    hasChanged() {
      return this.value !== this.opportunity.name;
    },
  },
  methods: {
    ...mapActions('opportunity', ['editOpportunity']),
    openDialog(opportunity) {
      this.opportunity = opportunity;
      this.value = opportunity.name;
      this.$refs.dialog.openModal();

      this.$nextTick(() => {
        const refInput = this.$refs.opportunityName.$el.querySelector('input, textarea');
        if (refInput) {
          this.$nextTick(() => {
            refInput.focus();
          });
        }
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      let body = {
        name: this.value.trim(),
        evaluationGridTemplateId: null,
        statusId: this.opportunity.status ? this.opportunity.status.id : null,
        startDate: this.opportunity.startDate,
        endDate: this.opportunity.endDate,
        source: this.opportunity.source,
        emitter: this.opportunity.emitter,
        notes: this.opportunity.notes,
        version: this.opportunity.version,
      };
      this.editOpportunity({ opportunityId: this.opportunity.id, opportunity: body });
      this.closeDialog();
    },
    handleKeyup(event) {
      const keyCode = event.keyCode || event.charCode;

      if (keyCode === 13) {
        if (!this.isFormInvalid) this.onSubmit();
        return;
      }
    },
    cancelClick() {
      this.closeDialog();
    },
  },
  created() {
    document.addEventListener('keyup', this.handleKeyup);
  },
  destroyed() {
    document.removeEventListener('keyup', this.handleKeyup);
  },
};
</script>

<style lang="scss">
.base-dialog__rename-opportunity {
  height: auto;
  width: 750px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.rename-opportunity {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }
}
</style>
